"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _context = require("../ConfigProvider/context");
var _useTracking2 = require("../../hooks/useTracking");
var _reactSvg = require("react-svg");
var _loading = _interopRequireDefault(require("../../assets/images/loading.svg"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var Button = function Button(props) {
  var _clsx;
  var _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    text = props.text,
    action = props.action,
    multiple_action = props.multiple_action,
    auto_action = props.auto_action,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    className = props.className,
    children = props.children,
    isUIOptimisationButton = props.isUIOptimisationButton,
    realText = props.realText;
  var type = props.type === 'frameless' ? 'secondary-outlined' : props.type || 'default';
  var context = (0, _react.useContext)(_context.ConfigContext);
  var _useTracking = (0, _useTracking2.useTracking)(props),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick,
    trackingImpressionProps = _useTracking.trackingImpressionProps;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    hasEmitedAutoAction = _useState2[0],
    setHasEmitedAutoAction = _useState2[1];
  var onClick = function onClick(e) {
    var _e$stopPropagation, _props$trackingData, _props$trackingData$t, _context$eventEmitter, _context$eventEmitter2, _props$onClick;
    e === null || e === void 0 ? void 0 : (_e$stopPropagation = e.stopPropagation) === null || _e$stopPropagation === void 0 ? void 0 : _e$stopPropagation.call(e); // 点击埋点

    trackingClick && tracker.click(_objectSpread(_objectSpread({}, trackingClick), {}, {
      data: _objectSpread(_objectSpread({}, (trackingClick === null || trackingClick === void 0 ? void 0 : trackingClick.data) || {}), (_props$trackingData = props.trackingData) === null || _props$trackingData === void 0 ? void 0 : (_props$trackingData$t = _props$trackingData.trackingdataClick) === null || _props$trackingData$t === void 0 ? void 0 : _props$trackingData$t.call(_props$trackingData, _objectSpread(_objectSpread({}, props.componentData || {}), {}, {
        disabled: disabled
      })))
    }));
    if (disabled) {
      var _props$onDisableClick;
      (_props$onDisableClick = props.onDisableClick) === null || _props$onDisableClick === void 0 ? void 0 : _props$onDisableClick.call(props, e);
      return;
    }
    if (loading) {
      var _props$onLoadingClick;
      (_props$onLoadingClick = props.onLoadingClick) === null || _props$onLoadingClick === void 0 ? void 0 : _props$onLoadingClick.call(props, e);
      return;
    }
    action && (context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, action === null || action === void 0 ? void 0 : action.func, {
      id: props._id,
      text: realText ? realText : text,
      action: action,
      multiple_action: multiple_action
    }, action.callback));
    (_props$onClick = props.onClick) === null || _props$onClick === void 0 ? void 0 : _props$onClick.call(props, e);
  };
  (0, _react.useEffect)(function () {
    if (disabled || hasEmitedAutoAction) {
      return;
    }
    if ((auto_action === null || auto_action === void 0 ? void 0 : auto_action.func) === 'autoPopupDriverOrderList') {
      var _context$eventEmitter3, _context$eventEmitter4;
      context === null || context === void 0 ? void 0 : (_context$eventEmitter3 = context.eventEmitter) === null || _context$eventEmitter3 === void 0 ? void 0 : (_context$eventEmitter4 = _context$eventEmitter3.emit) === null || _context$eventEmitter4 === void 0 ? void 0 : _context$eventEmitter4.call(_context$eventEmitter3, auto_action === null || auto_action === void 0 ? void 0 : auto_action.func, {
        id: props._id,
        text: text,
        action: action
      }, auto_action.callback);
      setHasEmitedAutoAction(true);
    }
  }, [props, hasEmitedAutoAction]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)('button'), (0, _getPrefixCls.getPrefixCls)('buttons'), (0, _getPrefixCls.getPrefixCls)("button-".concat(type)), (_clsx = {}, (0, _defineProperty2.default)(_clsx, (0, _getPrefixCls.getPrefixCls)("button-".concat(type, "__disabled")), disabled), (0, _defineProperty2.default)(_clsx, (0, _getPrefixCls.getPrefixCls)('button__loading'), loading), (0, _defineProperty2.default)(_clsx, (0, _getPrefixCls.getPrefixCls)('ui-optimisation-button'), isUIOptimisationButton && !disabled), _clsx), className),
    onClick: onClick,
    style: style
  }, trackingImpressionProps), loading && /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _loading.default,
    className: (0, _getPrefixCls.getPrefixCls)('button-loading-icon')
  }), children !== null && children !== void 0 ? children : /*#__PURE__*/_react.default.createElement("span", null, text));
};
exports.Button = Button;